import React from 'react'

export const NotFound: React.FC = () => {
  return <div>Page404</div>
}

export default NotFound
